// Total time to complete this function will be 15.5 seconds if maxRetries is 5
export async function retryFunctionWithExponentialBackoff<T>(
  fn: () => Promise<T>,
  maxRetries: number = 5,
  ): Promise<T> {
  const baseDelay = 2;
  for (let currentRetry = 0; currentRetry <= maxRetries; currentRetry++) {
    try {
      return await fn();
    } catch (error) {
      if (currentRetry === maxRetries) {
        throw error;
      }
      const delay = Math.pow(baseDelay, currentRetry) * 500;
      await new Promise((resolve) => setTimeout(resolve, delay));
    }
  }
  throw new Error(`Failed after exceeding max retries ${maxRetries}`);
}
